/**
 * Asset icon library: list of all supported icon names.
 * Icon names are passed to {@link IconRegistry#addSvgIcon}.
 */
export const ICON_LIBRARY = [
  // keep-sorted start
  'breaker',
  'bus',
  'energy_storage_system',
  'feeder',
  'fuse',
  'generator',
  'load',
  'pole',
  'recloser',
  'series_capacitor',
  'series_reactor',
  'shunt_capacitor',
  'shunt_reactor',
  'static_var_systems',
  'substation',
  'switch',
  'tower',
  'transformer',
  'transmission_line',
  'voltage_regulator',
  // keep-sorted end
] as const;

/** Type for supported asset icon names. */
export type AssetIconName = (typeof ICON_LIBRARY)[number];
